import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';

const api = axios.create({
    baseURL: '/',
    withCredentials: true,
    headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
    },
});

const readCookie = (name: string): string | null => {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
};

let csrfPromise: Promise<unknown> | null = null;
const fetchCsrf = () => {
    if (!csrfPromise) {
        csrfPromise = axios.get('/sanctum/csrf-cookie', { withCredentials: true });
    }
    return csrfPromise;
};

api.interceptors.request.use(async (config: InternalAxiosRequestConfig) => {
    if (!readCookie('XSRF-TOKEN')) {
        await fetchCsrf();
    }
    const token = readCookie('XSRF-TOKEN');
    if (token) {
        config.headers.set('X-XSRF-TOKEN', token);
    }
    return config;
});

api.interceptors.response.use(
    (r) => r,
    async (error: AxiosError) => {
        const original = error.config as InternalAxiosRequestConfig & { _retry?: boolean };
        if (error.response?.status === 419 && !original._retry) {
            original._retry = true;
            csrfPromise = null;
            await fetchCsrf();
            const token = readCookie('XSRF-TOKEN');
            if (token) {
                original.headers.set('X-XSRF-TOKEN', token);
            }
            return api.request(original);
        }
        return Promise.reject(error);
    },
);

export default api;
